import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import echarts from 'echarts'
import ElementUI from 'element-ui'
import common from './api/common'
import {post,get,patch} from './api/axios'
import * as filter from './api/filter'
import directive from './api/directive'
import Messages from './api/message'
import scrollTable from './utils/scrollTable'
import Pagination from './components/Pagination/index';
import SelectAll from './components/SelectAll/index';
import ShouJiCall from './components/ShouJiCall.vue';
import ShouJiSms from './components/ShouJiSms.vue'
import MyInput from './components/MyInput/index.vue';
import ScrollControl from './components/ScrollControl/index.vue';
import TextTooltip from './components/TextTooltip.vue';

//mixin
import uploadPlugin from './mixin/uploadPlugin'
Vue.use(uploadPlugin)

//引用第三方样式
import 'element-ui/lib/theme-chalk/index.css'
import './assets/element/element.css'
import './assets/fxn/fxn.css'
import './assets/fxn/common.css'
import './assets/fxn/style.css'
import './assets/fxn/iconfont.css'
import './assets/baseStyle/common.css'


Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(require('vue-wechat-title'))
Vue.prototype.axios = axios
Vue.prototype.post=post;
Vue.prototype.get=get;
Vue.prototype.$http=axios;
Vue.prototype.common = common
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$message = Messages


Vue.prototype.token = JSON.parse(localStorage.getItem('token'));

let OpenAside = new Vue()
Vue.prototype.OpenAside = OpenAside


// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('SelectAll', SelectAll)
Vue.component('ShouJiCall', ShouJiCall)
Vue.component('ShouJiSms', ShouJiSms)
Vue.component('MyInput', MyInput)
Vue.component('ScrollControl', ScrollControl)
Vue.component('TextTooltip', TextTooltip)

//全局过滤器
Object.keys(filter).forEach(key => { 
  Vue.filter(key, filter[key]) 
})

//全局指令
Object.keys(directive).forEach(key =>{
  Vue.directive(key, directive[key])
})

//配置模板导入/导出的URL地址---本地
// Vue.prototype.WebSocketUrl = 'wss://bama.amcmj.com:8890 '
// Vue.prototype.TextUrl = 'https://bama.amcmj.com:8809/'
// axios.defaults.baseURL = 'https://bama.amcmj.com:8809/'
// Vue.prototype.webUrl = 'https://bama.amcmj.com:8808/'
// Vue.prototype.callcenterUrl = "https://bama.amcmj.com:8809/"
// Vue.prototype.webrtcUrl = "https://call-prod.amcmj.com/"

//配置模板导入/导出的URL地址---正式
Vue.prototype.WebSocketUrl = 'wss://zws-api.bamafmc.com:2380/'
Vue.prototype.TextUrl = 'https://zws-api.bamafmc.com/'
axios.defaults.baseURL = 'https://zws-api.bamafmc.com/'
Vue.prototype.webUrl = 'https://zws.bamafmc.com/'
Vue.prototype.callcenterUrl = "https://zws-api.bamafmc.com/"
Vue.prototype.webrtcUrl = "https://call-uat.amcmj.com/"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js